module.exports = __webpack_public_path__ + "static/media/leituraQr.7b9929f1.png";